export const FULLSTORY_ORG_ID = 'VNNTT'